import { AuthProvider } from "./auth/AuthProvider.tsx";
import { useAuth } from "./auth/authContext.ts";
import { LoginPage } from "./pages/LoginPage.tsx";
import { VentasApp } from "./pages/ventas/VentasApp.tsx";
import { RecApp } from "./pages/rec/RecApp.tsx";
import { useAutoFieldLabels } from "./ui/useAutoFieldLabels.ts";

/**
 * Enrutamiento por rol — los DOS PLANOS del producto (§4 del plan):
 *   ventas              → plano de captura, fricción mínima (sólo el semáforo).
 *   rec / admin / auditor → plano de cumplimiento (toda la maquinaria).
 * Cada plano usa hash-routing propio para deep links y back button sin sumar
 * dependencia de router mientras el producto sigue chico.
 */
function Enrutador() {
  useAutoFieldLabels();
  const { session } = useAuth();
  if (!session) return <LoginPage />;
  if (session.rol === "ventas") return <VentasApp />;
  return <RecApp />;
}

export function App() {
  return (
    <AuthProvider>
      <Enrutador />
    </AuthProvider>
  );
}
